import { useLocation } from 'react-router-dom';
import { REMS_RESEND_IDP_INVITE_SUCCESS } from 'constants/identifierAndActions';
import SuccessComponent from 'components/SuccessComponent/SuccessComponent';
import IDPForm from './IDPForm';
import NameHeader from 'components/nameHeader/NameHeader';
import ProgressBar from 'components/Progress/ProgressBar';
import LoadingContent from 'components/LoadingContent/LoadingContent';
import FormWrapper from 'components/FormWrapper/FormWrapper';
import { useEffect } from 'react';
import { useAppSelector } from 'hooks/useRedux';
import { workflowActions, workflowSelectors } from 'state/workflow';
import { DO_NOT_WORRY } from 'constants/validationMessages';
import { useAppDispatch } from 'state/store';
import PersonalAssistant from 'components/PersonalAssistant/PersonalAssistant';
import { Container } from 'react-bootstrap';
import HighlightSection from 'components/HightlightSection/HighlightSection';

const IDP = () => {
  const location = useLocation();
  const identifier = location.state?.identifier;
  const isLoading = useAppSelector(workflowSelectors.loadingSelector);
  const dispatch = useAppDispatch();

  const error = useAppSelector(workflowSelectors.errorSelector);

  useEffect(() => {
    dispatch(workflowActions.setLoading(false));
  }, [error]);

  if (!identifier) {
    return null;
  }

  const stepSelector = 1;

  const renderForm = () => {
    if (identifier === REMS_RESEND_IDP_INVITE_SUCCESS) {
      return <SuccessComponent title={'IDP invite has been sent'} />;
    }

    return <IDPForm identifier={identifier} />;
  };

  return (
    <>
      <PersonalAssistant />

      <NameHeader
        serviceType={false}
        signOut
      />
      <HighlightSection>
        <ProgressBar
          steps={[
            { id: 0, label: 'Initial Onboarding' },
            { id: 1, label: 'Identity Proofing' },
            { id: 2, label: 'EPCS Registration' },
            { id: 3, label: 'Logical Access Control (LAC)' },
          ]}
          activeStep={stepSelector}
        />
      </HighlightSection>
      <Container>
        <FormWrapper
          text={`Step ${stepSelector + 1} of 4: Identity Proofing`}
          errorSubTitle={DO_NOT_WORRY}
        >
          {!isLoading ? renderForm() : <LoadingContent />}
        </FormWrapper>
      </Container>
    </>
  );
};

export default IDP;
